export default {"src":"/_next/static/media/Fotoservice.de87b9a5.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};